import { v4 as uuidv4 } from 'uuid'

export const productMixUsageTestData = {
  title: 'Produc Mix / Usage',
  item: '16.3% Alts',
  key: uuidv4()
}
